import { render, staticRenderFns } from "./YKRecord.vue?vue&type=template&id=65f0c7b1&scoped=true&"
import script from "./YKRecord.vue?vue&type=script&lang=js&"
export * from "./YKRecord.vue?vue&type=script&lang=js&"
import style0 from "./YKRecord.vue?vue&type=style&index=0&id=65f0c7b1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f0c7b1",
  null
  
)

export default component.exports